import React, { useEffect, useState, useRef } from "react";

import "./styles.scss";
import { RadarChart } from "./radarChart";
import chartService from '../../services/chart-sevices';
import { useDispatch } from "react-redux";
import { storeDataChart } from "../../reducer/chart-reducer";
import stringJp from '../../constants/stringJP';
import { Row, Col, Modal, Button } from 'antd';
import useWindowDimensions from "../../components/useWindowDemision";
import LineCharts from "../lineChart";
import { LeftOutlined, RightOutlined, LineChartOutlined } from '@ant-design/icons';

export default function Chart(props) {
    const {
        account_id,
        company_code,
        store_code,
        instore_code,
        security_key,
        setIsLoad,
        purchase_flag
    } = props;

    const [dataChart, setDataChart] = useState([]);
    const [recommendList, setRecommendList] = useState([]);
    const [user, setUser] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const { width } = useWindowDimensions();
    const [count, setCount] = useState(1);
    const dispatch = useDispatch();
    let scrl = useRef(null);
    const [scrollX, setscrollX] = React.useState(0);
    const [scrolEnd, setscrolEnd] = React.useState(false);
    const chartRef = useRef();
    const [datasets, setDatasets] = React.useState([]);
    const [labels, setLabels] = React.useState([]);
    const [dataCharts, setDataCharts] = React.useState({ labels: [], datasets: [] });

    const params = {
        account_id: account_id,
        company_code: company_code,
        security_key: security_key,
        store_code: store_code,
        instore_code: instore_code
    }

    React.useEffect(() => {
        const checkExist = (needForCheck) => !needForCheck
        chartService.getDataLineChart(params, (res) => {

            if (res.result === 'success') {

                const dataTree = [];
                const result = [];

                if (res.data) {
                    if (res.data.data) {
                        res?.data?.data?.forEach((item, index) => {
                            item.forEach((itemChild) => {

                                if (checkExist(dataTree[itemChild.title])) {
                                    dataTree[itemChild.title] = [];
                                }

                                dataTree[itemChild.title] = [
                                    ...dataTree[itemChild.title],
                                    itemChild.value
                                ]
                            })
                        })
                    }

                    if (res.data.listDay) {
                        setLabels(res.data.listDay);
                    }
                }

                for (const item in dataTree) {

                    result.push({
                        label: item,
                        dataRl: dataTree[item],
                        data: dataTree[item]?.map(item => item > 200 ? 200 : item),
                        pointRadius: 1
                    })
                }

                setDatasets(result);
            }
        }, (res) => {
            // setReason(res); 
            // setOpen(true) 
        })
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count]);

    React.useEffect(() => {
       
        if (datasets.length > 0 && labels.length > 0) {

            let labelConvert = [];

            labels.forEach(item => {
                labelConvert.push(
                    item.toString().slice(0, 3).replace(/^0+/, '')
                    + item.toString().slice(3, 6).replace(/^0+/, '')
                );
            });

            const dataChart = {
                labels: labelConvert,
                datasets: [
                    {
                        ...datasets[0],
                        borderColor: "#03a9f4",
                        backgroundColor: "#03a9f4",
                        // yAxisID: 'y',
                    },
                    {
                        ...datasets[1],
                        borderColor: "#742774",
                        backgroundColor: "#742774",
                        //  yAxisID: 'y',
                    },
                    {
                        ...datasets[2],
                        borderColor: "#ff9800",
                        backgroundColor: "#ff9800",
                        // yAxisID: 'y2',
                    },
                    {
                        ...datasets[3],
                        borderColor: "#009688",
                        backgroundColor: "#009688",
                        //yAxisID: 'y3',
                    },
                    {
                        ...datasets[4],
                        borderColor: "#4caf50",
                        backgroundColor: "#4caf50",
                        // yAxisID: 'y4',
                    },
                    {
                        ...datasets[5],
                        borderColor: "#ABB8C3",
                        backgroundColor: "#ABB8C3",
                        // yAxisID: 'y5',
                    }
                ]
            };
            setDataCharts(dataChart);
        }
    }, [datasets]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (purchase_flag === true) return;

        const params = {
            account_id: account_id,
            company_code: company_code,
            security_key: security_key,
            store_code: store_code,
            instore_code: instore_code
        };

        chartService.getDataChart(params, (res) => {
            //console.log("===> recommend_list:", res);
            setDataChart([...res?.data_chart])
            setUser({ ...res?.user_info })
            setRecommendList({ ...res?.recommend_list })
            dispatch(storeDataChart({ user: { ...res.user_info } }));
            setIsLoad(true)
        }, (res) => {
            // setReason(res); 
            // setOpen(true) 
        })

        return () => { // This code runs when component is unmounted
            setDataChart([])
            setUser({})
            setRecommendList({})
            setIsLoad(false)
        }
    }, [ account_id, company_code, store_code, instore_code, security_key, purchase_flag ]) // eslint-disable-line react-hooks/exhaustive-deps

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("genderchange", user.gender);
    localStorage.setItem("birthchange", user.birthday);
    localStorage.setItem("dataChart", JSON.stringify(dataChart));
    localStorage.setItem("recommendList", JSON.stringify(recommendList));

    const textChartBtn = {
        fontSize: width > 424 ? 424 * 0.0200 : width * 0.0210,
        paddingTop: 0,
        paddingRight: 10,
        textAlign: "end",
        fontWeight: 700
    }
    const textChartTop = {
        height: 30,
        fontSize: width > 424 ? 424 * 0.0250 : width * 0.0250,
        paddingTop: width > 424 ? 424 * 0.0400 : width * 0.0400,
        paddingRight: 10,
        marginBottom: 0,
        textAlign: "end",
        fontWeight: 700
    }
    const titleChart = {
        height: 30,
        fontSize: width > 424 ? 424 * 0.0450 : width * 0.0450,
        paddingTop: width > 424 ? 424 * 0.0230 : width * 0.0230,
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        paddingLeft: 10,
        marginBottom: 0,
        textAlign: "start",
        fontWeight: 700
    }

    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
        setscrollX(scrollX + shift);

        if (Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <= scrl.current.offsetWidth) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const scrollCheck = () => {
        setscrollX(scrl.current?.scrollLeft);
        if (
            Math.floor(scrl.current?.scrollWidth + scrl.current?.scrollLeft) <= scrl.current?.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    return (
        <div style={{ padding: '20px 17px 5px 17px' }}>
            <div className="chart-container">
                <Row>
                    <Col span={14}>
                        <h3 style={titleChart}>{stringJp.label_title_chart}</h3>
                    </Col>
                    <Col span={10}>
                        <h3 style={textChartTop}>{stringJp.label_subTitle_chart}</h3>
                    </Col>
                </Row>

                <div className="radar">
                    <RadarChart dataChart={dataChart} />
                </div>

                <Row style={{ marginTop: 0, marginBottom: 10 }}>
                    <Col span={8} >
                        <Button
                            style={{
                                position: 'absolute', bottom: 8, left: 8,
                                background: 'linear-gradient(270deg,rgba(0, 175, 235, 0.7) 0%, rgba(255, 255, 255, 0) 100%), rgba(51, 199, 232, 0.86)',
                            }}
                            onClick={() => {
                                setCount(count + 1)
                                setModalVisible(true)
                            }}
                            shape="circle"
                            size="large"
                            icon={<LineChartOutlined style={{ color: 'white', fontSize: 26 }} />} />

                    </Col>
                    <Col span={16}>
                        <h3 style={textChartBtn}>{stringJp.label_subTitle}</h3>
                        <h3 style={textChartBtn}>{stringJp.label_subTitle_right}</h3>
                        <h3 style={{ ...textChartBtn, paddingBottom: 2 }}>{stringJp.label_subTitle_right2}</h3>
                    </Col>
                </Row>

                <Modal
                    title="栄養価の推移"
                    visible={modalVisible}
                    onOk={() => setModalVisible(false)}
                    onCancel={() => setModalVisible(false)}
                    footer={null}
                    closable={true}
                >
                   
                    {!scrolEnd && (
                        <div className="round-icons-left" onClick={() => slide(-50)}>
                            <LeftOutlined style={{ color: '#FFFFFF', fontSize: 15 }} />
                        </div>)
                    }

                    {scrollX !== 0 && (
                        <div className="round-icons-right" onClick={() => slide(+50)}>
                            <RightOutlined style={{ color: '#FFFFFF', fontSize: 15 }} />
                        </div>)
                    }
                    <div className="modal-body-scr" ref={scrl} onScroll={scrollCheck} >
                        <LineCharts
                            scrollX={scrollX}
                            count={count}
                            chartRef={chartRef}
                            dataCharts={dataCharts}
                        />
                    </div>
                </Modal>
            </div>
        </div>
    );
}
